import React from 'react';
import { useTranslation } from 'react-i18next';
import { RemoteVideo } from 'amazon-chime-sdk-component-library-react';
import LocalCameraPreview from '../LocalCameraPreview';
import ContentShareVideo from '../ContentShareVideo';
import {
  fluidStyles,
  profileTileStyle,
  avatarStyle,
} from '../../styles/videoTileStyles';
import { getInitials } from '../../utils/participantUtils';
import {
  MainVideoFrame,
  ProfileMainCard,
  ProfileMainName,
  ProfileMainSubtext,
} from './style';

const ShareMainCard = ({ mainCard, getCardDisplayName }) => {
  const { t } = useTranslation();
  if (!mainCard) {
    return null;
  }

  if (mainCard.type === 'content-share') {
    return (
      <MainVideoFrame>
        <ContentShareVideo tileId={mainCard.tileId} />
      </MainVideoFrame>
    );
  }

  if (mainCard.type === 'remote-video') {
    return (
      <MainVideoFrame>
        <RemoteVideo
          tileId={mainCard.tileId}
          css="width: 100%; height: 100%; object-fit: contain;"
        />
      </MainVideoFrame>
    );
  }

  if (mainCard.type === 'local-camera') {
    return (
      <MainVideoFrame>
        <LocalCameraPreview key="share-main-local-camera" cssText={fluidStyles} />
      </MainVideoFrame>
    );
  }

  if (mainCard.type === 'profile') {
    const displayName = getCardDisplayName(mainCard);
    return (
      <ProfileMainCard style={profileTileStyle}>
        <div style={avatarStyle}>{getInitials(displayName)}</div>
        <ProfileMainName>{displayName}</ProfileMainName>
        <ProfileMainSubtext>{t('VideoChatV2.camera.off')}</ProfileMainSubtext>
      </ProfileMainCard>
    );
  }

  return null;
};

export default ShareMainCard;
